import baseConfig from './base'
export default {
  ...baseConfig,
  clickRewardApiBaseUrl: 'https://ads.tdeal.kr/admin/api/',
  ncpApiBaseUrl: 'https://api.e-ncp.com/',
  ncpClientId: 't9Bwi0oxige4SJwjVJhjmg==',
  tdealApiBaseUrl: 'https://front-admin.tdeal.kr/api/v1/',
  tdealApiBaseUrlV2: 'https://front-admin.tdeal.kr/api/v2/',
  partnerBaseUrlV2: 'https://partner.tdeal.kr/api/v2/',
  tdealFrontBaseUrl: 'https://tdeal.kr/product/',
  cdnUrl: 'cdn.tdeal.kr',
  tdealFrontUrl: 'https://tdeal.kr',
  partnerAdminApiUrl: 'https://partner.tdeal.kr/admin/api/',
  ncpOAuthParams: {
    systemKey : 'b1hLbVFoS1lUeUZTVDhhQVhTeVk2Zz09',
    appMallCode: 'SzlYN2tqbnRGemlyVUwwSmVTNS9mdkVKei9VRWJzU2M',
    redirectUrl: 'https://partner.tdeal.kr/admin/api/v2/login'
  }
}
